import { useRef } from "react";

export function useWindowConfigRef() {
  return useRef(window.config);
}
